import { CONTACT, NAV_LINKS } from "../data/siteContent";
import { useLenis } from "lenis/react";

const Footer = () => {
    const lenis = useLenis();
    return (
        <footer data-testid="site-footer" className="border-t border-[#D9D9D9] bg-[#FAFAFA] px-6 md:px-12 py-14">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <img
                        src="/logo-black.png"
                        alt="First Choice Trading Company"
                        className="h-12 w-auto"
                    />
                    <p className="mt-5 text-sm text-[#737373] leading-relaxed max-w-sm">
                        Manufacturers of parallel keys, lead screws, shafts, slide plates, MS
                        rollers and custom machine parts. A 40-year legacy of precision from
                        Ghaziabad, Uttar Pradesh.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <span className="text-xs uppercase tracking-[0.25em] text-copper">Explore</span>
                    <div className="mt-4 flex flex-col gap-2.5">
                        {NAV_LINKS.map((link) => (
                            <button
                                key={link.href}
                                data-testid={`footer-link-${link.label.toLowerCase()}`}
                                onClick={() => lenis?.scrollTo(link.href, { offset: -64, duration: 1.3 })}
                                className="text-left text-sm text-[#595959] hover:text-copper transition-colors duration-300"
                            >
                                {link.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="md:col-span-4">
                    <span className="text-xs uppercase tracking-[0.25em] text-copper">Reach Us</span>
                    <div className="mt-4 flex flex-col gap-2 text-sm text-[#595959]">
                        {CONTACT.emails.map((e) => (
                            <span key={e}>{e}</span>
                        ))}
                        {CONTACT.phones.map((p) => (
                            <span key={p}>{p}</span>
                        ))}
                        <span className="leading-relaxed">{CONTACT.address}</span>
                    </div>
                </div>
            </div>

            <div className="mt-12 pt-6 border-t border-[#E5E5E5] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                <span className="text-xs text-[#525252] uppercase tracking-[0.2em]">
                    © {new Date().getFullYear()} First Choice Trading Company. All rights reserved.
                </span>
                <span className="text-xs text-[#525252] uppercase tracking-[0.2em]">
                    Machined with precision since four decades
                </span>
            </div>
        </footer>
    );
};

export default Footer;
